<template>
  <div style="height:100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.4">
      <template #main>
        <div style="height:100%">
          <TableMain name="one table" ref="RolePrivilegeSetRef" :fields="fields" :title="table_title.title1"
            :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
            :show_date_picker="false" :show_toolbar="true" :show_filter="true" :show_check="true"
            :date_picker_label="date_picker_label" :query_button_label="query_lable" @on_query="on_query"
            :table_height_adjust="-6" @state_change="state_change" :show_toolbar_button="[1, 1, 0, 0, 1]"
            @current_changed="current_changed" :specialExport="true" @specialExport="exportRolePrivileges"
            @on_cell_button_click="on_cell_button_click" tableref="b7c2047756d44782a7d9127cc7c65a46">
            <template #specialExport>
              <el-dropdown-item command="specialExport" divided>{{ $t('common.rolePrivilegeExport')
              }}</el-dropdown-item>
            </template>
            <template #toolbar="">
              <el-button type="info" plain @click="createForm('new')" style="width: 55px"
                class="ml-2 iconfont icon-add-new" size="mini">
              </el-button>
              <el-badge :value="copyPrivilegesNum" :hidden="copyPrivilegesNum == 0"
                style="vertical-align: top !important">
                <el-tooltip content="拷贝所选角色拥有的权限" placement="top" effect="light">
                  <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-copy"
                    @click="copyPrivileges" size="mini">
                  </el-button>
                </el-tooltip>
              </el-badge>
              <el-tooltip content="权限粘贴" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-4 iconfont icon-paste"
                  @click="syncPrivileges" size="mini">
                </el-button>
              </el-tooltip>
              <el-tooltip content="权限追加" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-append"
                  @click="pastePrivileges" size="mini">
                </el-button>
              </el-tooltip>
            </template>
          </TableMain>
        </div>
      </template>
      <template #top>
        <TableMain name="rolePrivileges" :fields="fields2" :items="items" :show_check="true"
          :show_query_container="false" :show_toolbar="false" ref="rolePrivilegesRef" :title="'table_property'"
          :table_height_adjust="8" tableref="52ad18de8d134c428390bf52abc06af2">
          <template #operation>
            <el-button type="info" plain class="ml-2" @click="choosePrivileges"><i
                class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}</el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="roleOwnPrivileges" :fields="fields3" :items="items" :show_check="true"
          :show_query_container="false" :table_height_adjust="2" :show_toolbar="true" ref="roleOwnPrivilegesRef3"
          :title="'table_role_property'" @state_change="deleteP" :show_toolbar_button="[0, 0, 0, 0, 1]"
          tableref="176a0b09296b4697885276d5373fe859">
          <template #operation>
            <el-button type="success" plain size="mini" class="iconfont icon-save"
              @click="saveRoleOwnPrivileges">&nbsp;{{ $t("common.save") }}
            </el-button>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="dataForm.code"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="角色说明" prop="description">
            <el-input type="textarea" v-model="dataForm.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import SplitContainer3 from "../components/container/SplitContainer3"
import * as RolePropertyManageController from "../../controllers/system/RolePropertyManageController"

export default {
  name: "RolePrivilegeSet",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer3,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_role",
        title3: "table_role_user",
      },
      modal_title: "create_role",
      fields: RoleManageController.fields,
      fields2: RoleManageController.fields2,
      fields3: _.cloneDeep(RoleManageController.fields2),
      role_users_fileds: RoleManageController.role_users_fileds,
      dataForm: _.cloneDeep(RoleManageController.dataForm),
      rules: RoleManageController.rules,
      methods: RoleManageController.methods,
      roleName: "",
      items: [],
      selectedItem: null,
      roleHasData: [],
      roleNewData: [],
      copyPrivilegesNum: 0,
      copyItems: [],
      tab_index: 0,
    }
  },
  mounted() {
    this.GetPrivilige()
  },
  methods: {
    //选择权限
    choosePrivileges() {
      if (!this.selectedItem) {
        this.msgToasts("请选择角色后再选择!", "info")
        return
      }
      let items = []
      items = this.$refs.rolePrivilegesRef.GetSelectedItems()
      if (items.length < 1) {
        return
      }
      _.each(items, (t) => {
        if (!_.find(this.$refs.roleOwnPrivilegesRef3.my_data, { id: t.id })) {
          this.$refs.roleOwnPrivilegesRef3.InsertItems([
            {
              id: t.id,
              code: t.code,
              category: t.category,
              name: t.name,
              description: t.description,
              is_valid: t.is_valid,
            },
          ])
        }
      })
    },
    //同步
    async syncPrivileges() {
      let _this = this
      if (this.$refs.RolePrivilegeSetRef.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      this.msgModal(
        "从 " +
        this.$refs.RolePrivilegeSetRef.GetCurrentItem().code +
        " 复制权限到 " +
        _.join(
          _.map(_this.$refs.RolePrivilegeSetRef.GetSelectedItems(), "code"),
          ","
        ) +
        " 是否继续?"
      ).then(async (value) => {
        if (value) {
          let roleIds = []
          _.each(this.$refs.RolePrivilegeSetRef.GetSelectedItems(), (t) => {
            roleIds.push(t.id)
          })
          let _result = await RoleManageController.methods.syncRolePrivileges(
            roleIds,
            this.copyItems
          )
          if (_result && _result.length > 0) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
        }
      })
    },
    //追加
    async pastePrivileges() {
      let _this = this
      if (this.$refs.RolePrivilegeSetRef.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      this.msgModal(
        "从 " +
        this.$refs.RolePrivilegeSetRef.GetCurrentItem().code +
        " 追加权限到 " +
        _.join(
          _.map(_this.$refs.RolePrivilegeSetRef.GetSelectedItems(), "code"),
          ","
        ) +
        " 是否继续?"
      ).then(async (value) => {
        if (value) {
          let roleIds = []
          _.each(this.$refs.RolePrivilegeSetRef.GetSelectedItems(), (t) => {
            roleIds.push(t.id)
          })
          let _result = await RoleManageController.methods.pasteRolePrivileges(
            roleIds,
            this.copyItems
          )
          if (_result && _result.length > 0) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
        }
      })
    },
    //拷贝
    copyPrivileges() {
      this.copyItems = []
      if (!this.$refs.RolePrivilegeSetRef.GetCurrentItem()) {
        this.msgToasts("请选择要复制的角色!", "info")
        return
      }
      if (this.$refs.roleOwnPrivilegesRef3.my_data.length < 1) {
        this.copyPrivilegesNum = 0
        return
      }
      _.each(this.$refs.roleOwnPrivilegesRef3.my_data, (t) => {
        this.copyItems.push(t.id)
      })
      this.copyPrivilegesNum = this.copyItems.length
      this.msgToasts("已拷贝角色权限!", "success")
    },
    //编辑
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //保存角色权限
    async saveRoleOwnPrivileges() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择角色后再进行保存！", "warning")
        return
      }
      this.roleNewData = _this.$refs.roleOwnPrivilegesRef3.my_data

      let _b = await this.methods.SaveRolePrivileges(
        _this.selectedItem.id,
        _this.roleNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //获取权限
    async GetPrivilige() {
      let _dt = await this.methods.GetPrivilege()
      this.$refs.rolePrivilegesRef.SetData(_dt)
    },
    //#region 查询
    async on_query(set_data) {
      let _dt = await this.methods.GetRoleList()
      _dt = _.filter(_dt, { is_sys: false })
      set_data(_.orderBy(_dt, ["seq"], ["asc"]))
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_role"
          this.dataForm = _.cloneDeep(RoleManageController.dataForm)
          break
        case "edit":
          title = "edite_role"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    async saveData(cb) {
      let _this = this
      await this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          _this.addRole(_data, cb)
        } else {
          cb(false)
          return false
        }
      })
    },
    // 新增
    async addRole(_data, cb) {
      let b = await this.methods.AddRole({
        id: _data.id,
        name: _data.name,
        code: _data.code,
        description: _data.description,
        is_valid: _data.is_valid,
      })
      cb(true, b.success)
      //如果未新增则在表格中新增一条数据
      //如过修改 则在表格中修改
      if (_data.id) {
        let index = _.findIndex(this.$refs.RolePrivilegeSetRef.my_data, {
          id: _data.id,
        })
        if (index > -1) {
          this.$set(
            this.$refs.RolePrivilegeSetRef.my_data[index],
            "name",
            _data.name
          )
          this.$set(
            this.$refs.RolePrivilegeSetRef.my_data[index],
            "description",
            _data.description
          )
        }
      } else {
        if (_.findIndex(this.$refs.RolePrivilegeSetRef.my_data, { id: b.id }) < 0) {
          this.$refs.RolePrivilegeSetRef.my_data.splice(0, 0, {
            id: b.id,
            name: _data.name,
            code: _data.code,
            description: _data.description,
            is_valid: true,
            is_sys: true,
            _current: false,
            _id: b.id,
            _selected: false,
          })
        }
      }
    },
    //#endregion
    async deleteP(data, cb) {
      if (!this.selectedItem) {
        this.msgToasts("请选择角色!", "info")
        cb(false)
        return
      }

      let _b = await this.methods.deleteP(data, this.selectedItem.id)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.$refs.roleOwnPrivilegesRef3.RemoveItems(data.selected_items)
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#region 状态切换
    async state_change(data, cb) {
      let _b = await this.methods.UpdateRole(data)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#endregion

    current_changed(old, current) {
      //this.$emit("current_changed", old, current);
      if (!current) {
        return
      }
      this.selectedItem = current
      //获取角色对应的权限
      this.getRolePrivileges(current.id)
    },
    //获取角色对应的权限
    async getRolePrivileges(id) {
      this.$refs.roleOwnPrivilegesRef3.SetData([])
      let _this = this
      let _dt = await this.methods.GetRoleOwnPrivilege(id)
      this.roleHasData = _dt
      _this.$refs.roleOwnPrivilegesRef3.SetData(_dt)
    },

    //导出角色权限列表
    async exportRolePrivileges() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })
      let roleIds = []
      if (this.$refs.RolePrivilegeSetRef.my_data.length < 1) {
        loading.close()
        this.msgToasts(this.$t("notify.not_data"), "info")

        return
      }
      _.each(this.$refs.RolePrivilegeSetRef.my_data, (t) => {
        roleIds.push(t.id)
      })
      let selected_items = []
      let dataList =
        await RolePropertyManageController.methods.GetRoleAllPrivilegeList(
          roleIds
        )
      console.log(dataList)
      _.each(dataList, (t) => {
        _.each(t.result.data.Result, (y) => {
          selected_items.push(y)
        })
      })


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = RoleManageController.role_users_export_fileds
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, this.$t("table.table_role_property"), "", loading)
      })
    },
    //导出角色用户列表
    async exportRoleUsers() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })

      let selected_items = []
      let dataList = await RoleManageController.methods.getRoleUsers()
      if (dataList && dataList.length > 0) {
        _.each(dataList[0], (t) => {
          selected_items.push(t)
        })
      } else {
        loading.close()
        this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = RoleManageController._role_users_fileds
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, "人员角色列表", "", loading)
      })
    },
  },
}
</script>
<style>
.role-table {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 1000px;
}
</style>
